<nav class="navbar">
  @if (userService.isLogined()) {
    <p-button
      label="ログアウト"
      class="nav-button"
      styleClass="p-button-info p-button-sm"
      icon="pi pi-sign-out"
      iconPos="left"
      (click)="logout()"></p-button>
  }
  @if (!userService.isLogined()) {
    <p-button
      label="ログイン"
      class="nav-button"
      styleClass="p-button-info p-button-sm"
      icon="pi pi-sign-in"
      iconPos="left"
      (click)="goLogin()"></p-button>
  }
  <span
    class="clickable logo"
    routerLink="/">
    らくじゃん
    @if (!!subtitle) {
      <span class="subtitle"></span>
    }
    - {{ subtitle }}
  </span>
</nav>
@if (userService.isLogined() && !userService.hasRefreshToken() && userService.hasFuncShare()) {
  <a
    href="https://sellercentral.amazon.co.jp/apps/authorize/consent?application_id=amzn1.sellerapps.app.2061b3cc-fc3b-48cc-8b52-fd333bc47f68&state=link"
    class="amazon-warning-banner">
    Amazon連携が完了していません。ここをクリックして連携してください。
  </a>
}
@if (loading) {
  <ng-http-loader
    [backdrop]="false"
    [debounceDelay]="50"
    [extraDuration]="100"
    [minDuration]="100"
    [opacity]="0.6"
    [spinner]="spinkit.skDoubleBounce"
    [threshold]="0"></ng-http-loader>
}
<app-flash-message></app-flash-message>
<div class="container">
  <router-outlet></router-outlet>
</div>
